import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import * as Common from 'common/components';
import { Form } from 'common/components';

class AssetsDisableEnableModal extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleClose: PropTypes.func.isRequired,
    handleAccept: PropTypes.func.isRequired,
  };

  handleAccept = (e) => {
    e && e.preventDefault();
    this.props.handleAccept();
  };

  handleClose = (e) => {
    e && e.preventDefault();
    this.props.handleClose();
  };

  render = () => (
    <Common.Modal show={this.props.isOpened} handleClose={this.handleClose} keyboard={false}>
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">{this.props.t('assets.enable_title')}</h5>
          <button type="button" className="close" onClick={this.handleClose} text={'x'}>
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div
          className="modal-body"
          dangerouslySetInnerHTML={{
            __html: this.props.t('assets.enable_confirm', this.props.asset),
          }}
        />
        <div className="modal-footer">
          <Form.Button
            type="button"
            className="btn btn-secondary"
            text={this.props.t('actions.cancel')}
            onClick={this.handleClose}
          />

          <Form.Button
            type="button"
            className="btn btn-warning"
            text={this.props.t('actions.confirm')}
            onClick={this.handleAccept}
          />
        </div>
      </div>
    </Common.Modal>
  );
}

export default translate()(AssetsDisableEnableModal);



// WEBPACK FOOTER //
// src/components/assets/disable/AssetsDisableEnableModal.js